import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DiskCapacityInfo = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${33 * Screen.widthRatio}px;
  font-size: ${33 * Screen.widthRatio}px;
  margin-top: ${36 * Screen.widthRatio}px;
`;

export default DiskCapacityInfo;
